import React, {Component} from 'react';
import {Paper, Chip} from 'material-ui';
import _isEmpty from 'lodash/isEmpty';
import TagsDisplayList from '../tags_display_list';

class PageVersionsHeaderInfo extends Component {

    render() {
        const {
            classes,
            page
        } = this.props;

        let pageTags = page.tags !== undefined ? page.tags : {};
        let hasTags = Object.values(pageTags).map(item => item);
        let pageUrl = page.url ? page.url : "not set";
        let parentPage = !_isEmpty(this.props.page.parent_page) ?
            this.props.page.parent_page.title : 'None';

        return (
            <Paper elevation={2} className={classes.marginBottom10}>
                <Chip
                    label={page.site}
                    className={classes.chipPageWebsite}
                />
                <Chip
                    label={
                        <span>
                            Page Type: <span className={classes.chipTextGreen}>{page.type}</span>
                        </span>
                    }
                />
                <Chip
                    label={
                        <span>
                            Parent Page:  <span className={classes.chipTextGreen}>{parentPage}</span>
                        </span>
                    }
                    className={classes.chipParentPage}
                />
                <Chip
                    label={
                        <span>
                            URL: <span className={classes.chipTextGreen}>{pageUrl}</span>
                        </span>
                    }
                />
                {page.product_tagos_id &&
                    <Chip
                        label={
                            <span>
                                Product Tagos ID: <span className={classes.chipTextGreen}>{page.product_tagos_id}</span>
                            </span>
                        }
                        className={classes.chipWebsite}
                    />
                }
                {pageTags && hasTags.join('').length > 0 &&
                <Chip
                    label={
                        <span className={classes.chipPageTagsLabel}>
                            Page Tags: <span className={classes.chipTextGreen}>
                                <TagsDisplayList 
                                    pageTagsForDisplay={pageTags}
                                    classes={classes}
                                />
                            </span>
                        </span>
                    }
                    className={classes.chipPageTagsVersions}
                />
                }
            </Paper>
        );
    }
}

export default PageVersionsHeaderInfo;


// WEBPACK FOOTER //
// ./src/containers/builder/versions/PageVersionsHeaderInfo.jsx